module.exports = __webpack_public_path__ + "static/media/1-min.24b1e84d.png";